import { connect } from 'react-redux';
import { Checklist } from '../../../common/components/checklist/checklist';
import { IState } from '../../../store';
import { isPassportVerified, isRosreestrVerified } from '../../../utils/agent';

const ROS_REG_PASSED = 'Проверен в Росреестре';
const PASSPORT_PASSED = 'Предоставлен паспорт';

export const OwnerChecksContainer = connect(({ offerData: { offer, agent } }: IState) => ({
  items: [agent && isPassportVerified(agent) && PASSPORT_PASSED, isRosreestrVerified(offer) && ROS_REG_PASSED].filter(
    Boolean,
  ) as string[],
}))(Checklist);
